import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './fonts.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'primeflex/primeflex.min.css';

const rootElement = document.getElementById('root');

// When react-snap has prerendered the page, the root already contains markup —
// hydrate it so the static HTML (and its SEO meta) is reused. Otherwise mount fresh.
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
